import { useState } from "react";
import { useTranslation } from "react-i18next";

const ModalNuevaContrasena = ({ isOpen, usuario, onCancel, onAccept }) => {
    const { t } = useTranslation();
    const [password, setPassword] = useState("");

    const charLength = 32;

    const handleAccept = () => {
        if (password.length < 5) {
            alert(t('alert_debe_ingresar_contrasena_de_5_caracteres_minimo'));
            return;
        }
        if (onAccept) {
            onAccept(password);
        }
        setPassword("");
    };

    const handleCancel = () => {
        setPassword("");
        if (onCancel) {
            onCancel();
        }
    };

    return (
        <>
            {isOpen && (
                <div className="fixed z-50 top-0 left-0 right-0 bottom-0 flex items-center justify-center">
                    <div className="fixed inset-0 bg-gray-500 opacity-75"></div>
                    <div className="bg-white w-11/12 md:max-w-md mx-auto rounded shadow-lg z-50 overflow-y-auto">
                        <div className="py-4 text-left px-6">
                            <div className="mb-4">
                                <h3 className="text-xl font-semibold text-gray-900 mb-4">
                                    {usuario?.nombre ?? ""}
                                </h3>
                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                    {t('label_nueva_contrasena')}
                                </label>
                                <input
                                    type="text"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    maxLength={32}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                                    placeholder={t('label_ingrese_contrasena')}
                                />
                                <p className="text-xs text-gray-500 mt-1 text-right">
                                    {password.length}/{charLength}
                                </p>
                            </div>
                            <div className="flex justify-end">
                                <button
                                    className="mr-4 inline-flex justify-center px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 border border-transparent rounded-md hover:bg-gray-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-500"
                                    onClick={handleCancel}
                                >
                                    {t('btn_cancelar')}
                                </button>
                                <button
                                    className="inline-flex justify-center px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md hover:bg-blue-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-500"
                                    onClick={handleAccept}
                                >
                                    {t('btn_aceptar')}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default ModalNuevaContrasena;
